import React from 'react';
import ReactDOM from 'react-dom/client';
import { HelmetProvider } from 'react-helmet-async';
import './index.css';
import App from './App';
import reportWebVitals from './reportWebVitals';

const toText = (value) => {
  if (value == null) return '';
  if (typeof value === 'string') return value;
  if (typeof value === 'object') {
    return [
      value.message,
      value.reason,
      value.stack,
      value.name,
      value.code,
    ].filter(Boolean).join(' ');
  }
  return String(value);
};

const isIgnorableTimeout = (payload) => {
  const text = toText(payload).toLowerCase();
  if (!text.includes('timeout')) return false;
  if (text.trim() === 'timeout') return true;
  return (
    text.includes('recaptcha') ||
    text.includes('grecaptcha') ||
    text.includes('google') ||
    text.includes('clarity') ||
    text.includes('analytics') ||
    text.includes('gtag')
  );
};

const suppressEvent = (event) => {
  event.preventDefault();
  if (typeof event.stopImmediatePropagation === 'function') {
    event.stopImmediatePropagation();
  }
  event.stopPropagation();
};

window.addEventListener('error', (event) => {
  const payload = [event.message, event.error, event.filename, event?.reason].filter(Boolean).join(' ');
  if (isIgnorableTimeout(payload)) {
    suppressEvent(event);
    return true;
  }
}, true);

window.addEventListener('unhandledrejection', (event) => {
  if (isIgnorableTimeout(event.reason)) {
    suppressEvent(event);
    return true;
  }
}, true);

const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
  <React.StrictMode>
    <HelmetProvider>
      <App />
    </HelmetProvider>
  </React.StrictMode>
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
